var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBlob(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 109,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.786 45.178a51.959 51.959 0 00-1.614-9.042c-1.52-12.309-8.907-24.045-18.741-31.533-4.994-3.807-11.685-6.08-17.773-3.504-2.856 1.208-4.75 3.435-6.637 5.79-1.845 2.31-3.824 4.254-6.623 5.377-5.927 2.378-12.495 1.21-18.448-.387-6.496-1.74-13.026-4.053-19.853-3.684-5.78.315-11.383 2.462-14.873 7.242-3.405 4.666-4.066 10.849-3.569 16.448.27 3.08 1.38 6.297 1.11 9.378-.265 2.982-2.696 4.823-4.994 6.369-2.437 1.643-4.83 3.251-6.85 5.404A28.752 28.752 0 00.471 77.08c.911 5.693 3.735 10.949 7.488 15.285 8.576 9.933 21.516 14.107 34.244 15.317 13.974 1.329 28.078.018 41.114-5.355a98.452 98.452 0 0017.87-9.698c5.353-3.644 10.487-7.73 14.713-12.661 8.24-9.615 12.001-22.233 10.886-34.79z",
    fill: "#229490"
  }))));
}

export default SvgBlob;